export const PDF_VIEWER_ROTATION_STEP = 90
